import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import MasterPage from '../../layouts/MasterPage';
import { Link } from 'react-router-dom';
import authAPI from '../../api/authAPI';
import AuthenticationManager from '../../services/StorageJWT';
import gameAPI from '../../api/gameAPI';
import profileAPI from '../../api/profileAPI';
import { Button, Spinner } from 'react-bootstrap';
import PopupBox from '../../components/PopupBox';
import { onKeyDown } from '../../services/Tools';

const Code = () => {
  const navigate = useNavigate();
  const [errorText, setErrorText] = useState('');
  const [show, setShow] = useState(false);
  const [code, setCode] = useState(null);
  const [error, setError] = useState(false);
  const _auth = new AuthenticationManager();
  const [loading, setLoading] = useState(false);
  const onSubmit=()=>{
    if ( !code ) {
   
      setError(true);
      return;
    }
    gameAPI.sendCode(code,_auth._token)
    .then(res=>navigate("/menu/assist",{state:{prePage:"code"}}))
    .catch(e => {
      if(e?.response?.status==422){
        setShow(true);
        setErrorText("کد وارد شده صحیح نیست. دوباره امتحان کنید")
      }
      else if(e?.response?.status==423){
        setShow(true);
        setErrorText("برای اکانت شما از قبل این بازی ثبت شده است.")
      }
    })
    .finally(()=>setLoading(false))
  }

  return (
    <MasterPage>
      <div className="structure-page structure-page-4 login p-3 body menu ">
        <div className="text-center w-100 mt-3 games">
        <div className="form-group  mb-1 w-100">
            <label htmlFor="name">
              کد اختصاصی بازی <span className="text-danger">*</span>
            </label>
            <input
              onChange={(e) => setCode(e.target.value)}
              onKeyDown={(e)=>onKeyDown(e,onSubmit)}
              type="text"
              value={code}
              className={`form-control w-100 ${
                !code && error ? 'is-invalid' : ''
              }`}
              placeholder="تایپ کنید"
            />
          </div>
          <PopupBox show={show} setShow={setShow} text={errorText} />

        </div>
        <div className='d-grid gap-2 w-100'>
        <Button
          variant="dark"
          className="btn btn-submit d-flex justify-content-center  mt-4"
          onClick={onSubmit}
        >
          {loading ? (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              className="p-2"
              role="status"
              aria-hidden="true"
            />
          ) : (
          <span className='mt-1'> ثـبـت</span>
          )}
        </Button>
        <button
          onClick={() => window.history.back()}
          className="btn btn-return pt-2 pb-2 w-100"
        >
          بازگشت
        </button>
        </div>
       
      </div>
    </MasterPage>
  );
};

export default Code;
